<template>
  <nav class="rx-version-bar" aria-label="서비스 버전">
    <span class="rx-version-label">화면 버전</span>
    <div class="rx-version-tabs" role="tablist" aria-label="화면 버전">
      <template v-if="standalone">
        <a role="tab" aria-selected="false" href="https://expert.richgo.ai/legacy">구버전</a>
        <a role="tab" aria-selected="true" href="https://expert.richgo.ai/insight">신버전</a>
      </template>
      <template v-else>
        <button v-for="version in versions" :id="`expert-version-${version.key}`" :key="version.key" ref="tabs" type="button" role="tab" :aria-selected="presentation.renewed === version.renewed ? 'true' : 'false'" :tabindex="presentation.renewed === version.renewed ? 0 : -1" aria-controls="expert-version-content" @click="select(version.renewed)" @keydown="onKey($event)">{{ version.label }}</button>
      </template>
    </div>
  </nav>
</template>
<script>
import { presentation, setPresentation } from './presentation';
import { versionDestination } from './version-navigation';
export default {
  props: { standalone: { type: Boolean, default: false } },
  data: () => ({ presentation, returnPair: null, versions: [
    { key: 'legacy', label: '구버전', renewed: false },
    { key: 'new', label: '신버전', renewed: true }
  ] }),
  methods: {
    select(renewed) {
      if (renewed === this.presentation.renewed) return;
      const destination = versionDestination(renewed, this.$route, this.returnPair);
      this.returnPair = destination.returnPair;
      setPresentation(renewed);
      this.$store.commit('showDrawer', false);
      if (destination.path) this.$router.push(destination.path);
    },
    onKey(event) {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      const renewed = event.key === 'Home' ? false : event.key === 'End' ? true : !this.presentation.renewed;
      this.select(renewed);
      this.$nextTick(() => this.$refs.tabs[renewed ? 1 : 0].focus());
    }
  }
};
</script>
<style>
@import '../styles/expert-typography.css';
.expert-version-shell { --expert-version-height: 34px; }
.rx-version-bar {
  position: sticky; top: 0; z-index: 150; display: flex; align-items: center;
  justify-content: flex-end; gap: 20px; flex: none; height: 34px; min-height: 34px;
  padding: 0 28px; background: #172c46; color: #fff; box-sizing: border-box;
}
.rx-version-label { font-size: 13px; font-weight: 500; color: #cbd5e1; }
.rx-version-tabs { display: flex; align-self: stretch; gap: 0; }
.rx-version-bar .rx-version-tabs button,
.rx-version-bar .rx-version-tabs a {
  display: flex; align-items: center; justify-content: center; min-width: 80px;
  margin: 0; padding: 0 16px; border: 0; border-bottom: 2px solid transparent;
  border-radius: 0; background: transparent; color: #cbd5e1 !important;
  font: inherit; font-size: 13px; font-weight: 500; cursor: pointer; text-decoration: none;
}
.rx-version-bar .rx-version-tabs [aria-selected=true] {
  background: #fff; color: #202b3b !important; border-bottom-color: #165bd8; font-weight: 650;
}
.rx-version-bar .rx-version-tabs [aria-selected=false]:hover { background: #263e5b; color: #fff !important; }
.rx-version-tabs :focus-visible { outline: 2px solid #8cb6ff; outline-offset: -4px; }
.rx-version-tabs [aria-selected=true]:focus-visible { outline-color: #165bd8; }
.expert-version-shell .expert-analysis-drawer.v-navigation-drawer {
  top: var(--expert-version-height) !important; height: calc(100% - var(--expert-version-height)) !important;
}
.expert-version-shell .drawer-menu-button { top: calc(110px + var(--expert-version-height)); }
.expert-version-shell .drawer-menu-button2 { top: calc(50px + var(--expert-version-height)); }
.expert-version-shell .region-group { scroll-margin-top: 60px; }
@media (max-width: 720px) {
  .expert-version-shell .drawer-menu-button,
  .expert-version-shell .drawer-menu-button2 { top: calc(var(--expert-version-height) - 3px); }
}
@media (max-width: 600px) {
  .expert-version-shell { --expert-version-height: 40px; }
  .rx-version-bar { height: 40px; min-height: 40px; padding: 0 16px; gap: 12px; }
  .rx-version-bar .rx-version-tabs button,
  .rx-version-bar .rx-version-tabs a { min-width: 72px; padding: 0 14px; }
}
</style>
